module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst {\nrenderHtmlWrapper,\ntitle,\nsubTitle,\nmessage,\nimage: {\nurl: imageUrl,\n} = {},\nshowErrorCode,\n} = utils.error.prepare(locals)\nconst baseUrl = (((storage || {}).app || {}).service || {}).url\nconst fallbackImageUrl = `${baseUrl}/images/error.jpg`\nif(renderHtmlWrapper){\n%>\n<!doctype html>\n<html lang=\"<%- storage.langCode %>\">\n<head>\n<title><%= title %></title>\n<link type=\"text/css\" rel=\"stylesheet\" href=\"<%- baseUrl %>/webpack/css/app.css\" />\n</head>\n<body class=\"errorContainer\">\n<%\n}\n%>\n<div class=\"errors_errors\">\n<section><div class=\"image\" style=\"background-image: url(<%- imageUrl || fallbackImageUrl %>);\"></div></section>\n<section><%\nif(title){\n%><h1><%= title %></h1><%\n}\nif(subTitle){\n%><h2><%= subTitle %></h2><%\n}\nif(message){\n%><%- message %><%\n}\n%></section><%\nif(showErrorCode){\n%><section class=\"errorCode\"><%- showErrorCode %></section><%\n}\n%></div>\n<%\nif(renderHtmlWrapper){\n%>\n</body>\n</html>\n<%\n}\n%>"
  , __filename = "..\\frontend-controller\\baseComponents\\errors\\errors.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const {
renderHtmlWrapper,
title,
subTitle,
message,
image: {
url: imageUrl,
} = {},
showErrorCode,
} = utils.error.prepare(locals)
const baseUrl = (((storage || {}).app || {}).service || {}).url
const fallbackImageUrl = `${baseUrl}/images/error.jpg`
if(renderHtmlWrapper){

    ; __line = 15
    ; __append("\n<!doctype html>\n<html lang=\"")
    ; __line = 17
    ; __append( storage.langCode )
    ; __append("\">\n<head>\n<title>")
    ; __line = 19
    ; __append(escapeFn( title ))
    ; __append("</title>\n<link type=\"text/css\" rel=\"stylesheet\" href=\"")
    ; __line = 20
    ; __append( baseUrl )
    ; __append("/webpack/css/app.css\" />\n</head>\n<body class=\"errorContainer\">\n")
    ; __line = 23
    ; 
}

    ; __line = 25
    ; __append("\n<div class=\"errors_errors\">\n<section><div class=\"image\" style=\"background-image: url(")
    ; __line = 27
    ; __append( imageUrl || fallbackImageUrl )
    ; __append(");\"></div></section>\n<section>")
    ; __line = 28
    ; 
if(title){

    ; __line = 30
    ; __append("<h1>")
    ; __append(escapeFn( title ))
    ; __append("</h1>")
    ; 
}
if(subTitle){

    ; __line = 33
    ; __append("<h2>")
    ; __append(escapeFn( subTitle ))
    ; __append("</h2>")
    ; 
}
if(message){

    ; __line = 36
    ; __append( message )
    ; 
}

    ; __line = 38
    ; __append("</section>")
    ; 
if(showErrorCode){

    ; __line = 40
    ; __append("<section class=\"errorCode\">")
    ; __append( showErrorCode )
    ; __append("</section>")
    ; 
}

    ; __line = 42
    ; __append("</div>\n")
    ; __line = 43
    ; 
if(renderHtmlWrapper){

    ; __line = 45
    ; __append("\n</body>\n</html>\n")
    ; __line = 48
    ; 
}

    ; __line = 50
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=..\frontend-controller\baseComponents\errors\errors.ejs

}